import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class ExcelProjectImport_ds_get_project_by_lookupcode_ownerLookupcodeService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get(inParams: { projectLookupcode: string, ownerLookupcode: string }): 
  Promise<{ result: { Id?: number, LookupCode?: string, OwnerId?: number, Owner?: { LookupCode?: string } } }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.projectLookupcode)) {
      missingRequiredInParams.push('\'projectLookupcode\'');
    }
    if (isNil(inParams.ownerLookupcode)) {
      missingRequiredInParams.push('\'ownerLookupcode\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/ExcelProjectImport/datasources/ds_get_project_by_lookupcode_ownerLookupcode/get`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }


    
    hasMissingRequiredInParams(inParams: { 
      projectLookupcode: string, ownerLookupcode: string    }) {
        if(isNil(inParams.projectLookupcode)) {
          return true; 
        }
        if(isNil(inParams.ownerLookupcode)) {
          return true; 
        }
      return false;
    }
}
